export enum OfferUnavailableReason {
  SOLD_OUT = 'SOLD_OUT',
  CAPACITY_EXCEEDED = 'CAPACITY_EXCEEDED',
  DATE_UNAVAILABLE = 'DATE_UNAVAILABLE',
  NUM_NIGHTS_UNSUPPORTED = 'NUM_OF_NIGHTS_UNSUPPORTED',
  NO_PRICES_FOUND = 'NO_PRICES_FOUND'
}

export const ELIGIBLE_FOR_HOTEL_LOYALTY_POINTS_INCLUSION_DESCRIPTION = 'Eligible for hotel loyalty points'
